export const districtsArray = [
  'Legnica',
  'Wałbrzych',
  'Wrocław',
  'Bydgoszcz',
  'Toruń',
  'Lublin',
  'Chełm',
  'Zielona Góra',
  'Łódź',
  'Piotrków Trybunalski',
  'Sieradz',
  'Kraków I (południe)',
  'Kraków II (północ)',
  'Nowy Sącz',
  'Tarnów',
  'Płock',
  'Radom',
  'Siedlce',
  'Warszawa I (miasto)',
  'Warszawa II (okręg)',
  'Opole',
  'Krosno',
  'Rzeszów',
  'Białystok',
  'Gdańsk',
  'Słupsk',
  'Bielsko-Biała',
  'Częstochowa',
  'Katowice',
  'Bielsko-Biała',
  'Katowice',
  'Sosnowiec',
  'Kielce',
  'Elbląg',
  'Olsztyn',
  'Kalisz',
  'Konin',
  'Piła',
  'Poznań',
  'Koszalin',
  'Szczecin',
];

export const seatsArray = [
  12,
  8,
  14,
  12,
  13,
  15,
  12,
  12,
  10,
  9,
  12,
  8,
  14,
  10,
  9,
  10,
  9,
  12,
  20,
  12,
  12,
  11,
  15,
  14,
  12,
  14,
  9,
  7,
  9,
  9,
  12,
  9,
  16,
  8,
  10,
  12,
  9,
  9,
  10,
  8,
  12,
];

export const electionResults = `"Nr okręgu";"Liczba komisji";"Liczba uwzględnionych komisji";"Komisja otrzymała kart do głosowania";"Liczba wyborców uprawnionych do głosowania";"Nie wykorzystano kart do głosowania";"Liczba wyborców, którym wydano karty do głosowania";"Liczba wyborców, którym wysłano pakiety wyborcze";"Liczba wyborców, którym wydano karty do głosowania w lokalu wyborczym oraz w głosowaniu korespondencyjnym (łącznie)";"Liczba wyborców głosujących przez pełnomocnika";"Liczba wyborców głosujących na podstawie zaświadczenia o prawie do głosowania";"Liczba otrzymanych kopert zwrotnych";"Liczba kopert zwrotnych, w których nie było oświadczenia o osobistym i tajnym oddaniu głosu";"Liczba kopert zwrotnych, w których oświadczenie nie było podpisane";"Liczba kopert zwrotnych, w których nie było koperty na kartę do głosowania";"Liczba kopert zwrotnych, w których znajdowała się niezaklejona koperta na kartę do głosowania";"Liczba kopert na kartę do głosowania wrzuconych do urny";"Liczba kart wyjętych z urny";"W tym liczba kart wyjętych z kopert na kartę do głosowania";"Liczba kart nieważnych";"Liczba kart ważnych";"Liczba głosów nieważnych";"W tym z powodu postawienia znaku „X” obok nazwiska dwóch lub większej liczby kandydatów z różnych list";"W tym z powodu niepostawienia znaku „X” obok nazwiska żadnego kandydata";"W tym z powodu postawienia znaku „X” wyłącznie obok nazwiska kandydata na liście, której rejestracja została unieważniona";"Liczba głosów ważnych oddanych łącznie na wszystkie listy kandydatów";"KOMITET WYBORCZY BEZPARTYJNI SAMORZĄDOWCY";"KOALICYJNY KOMITET WYBORCZY TRZECIA DROGA POLSKA 2050 SZYMONA HOŁOWNI - POLSKIE STRONNICTWO LUDOWE";"KOMITET WYBORCZY NOWA LEWICA";"KOMITET WYBORCZY PRAWO I SPRAWIEDLIWOŚĆ";"KOMITET WYBORCZY KONFEDERACJA WOLNOŚĆ I NIEPODLEGŁOŚĆ";"KOALICYJNY KOMITET WYBORCZY KOALICJA OBYWATELSKA PO .N IPL ZIELONI";"KOMITET WYBORCZY POLSKA JEST JEDNA";"KOMITET WYBORCZY WYBORCÓW RUCHU DOBROBYTU I POKOJU";"KOMITET WYBORCZY NORMALNY KRAJ";"KOMITET WYBORCZY ANTYPARTIA";"KOMITET WYBORCZY RUCH NAPRAWY POLSKI";"KOMITET WYBORCZY WYBORCÓW MNIEJSZOŚĆ NIEMIECKA"
1;823;823;674048;716400;162105;511926;251;512177;1016;11196;244;27;5;5;5;202;512050;202;218;511832;9962;5864;4098;0;501870;16748;53958;47715;174643;31770;169540;7496;;;;;
2;574;574;445128;476857;115429;329661;216;329877;761;7157;203;28;2;1;1;171;329813;171;123;329690;6330;4135;2195;0;323360;5808;39215;25806;107797;19478;120188;5068;;;;;
3;894;894;937158;1006283;151525;785578;491;786069;1110;14233;460;29;3;1;5;423;785861;424;343;785518;9464;5138;4326;0;776054;22412;106624;88089;206899;54132;286713;11185;;;;;
4;957;957;694008;745557;149559;544485;426;544911;879;8692;399;40;4;3;4;349;544737;350;177;544560;10641;6498;4143;0;533919;8905;80426;52959;162603;34266;186914;7846;;;;;
5;960;960;725243;779436;175430;549804;276;550080;1105;11762;266;29;2;3;2;230;549931;231;248;549683;12086;6642;4382;1062;537597;7758;84308;60473;183131;34232;158719;6710;2266;;;;
6;1109;1109;854827;903524;195468;659413;388;659801;1662;9488;361;18;3;0;3;339;659610;335;265;659345;10998;5368;4437;1193;648347;10344;102894;37083;294847;54325;131712;14892;2250;;;;
7;1072;1072;656231;693111;189647;466464;237;466701;1336;7632;223;22;5;1;2;193;466548;195;113;466435;9563;6030;3533;0;456872;9522;59577;25691;231882;35594;79501;12930;2175;;;;
8;883;883;693385;741917;163763;529580;334;529914;824;10170;314;27;3;2;7;276;529743;276;263;529480;12439;7294;3990;1155;517041;11954;77933;47911;143530;33672;195091;5794;;;1156;;
9;454;454;548729;581567;87735;461204;391;461595;730;7875;343;33;6;0;1;307;461069;307;333;460736;4184;2184;2000;0;456552;5624;54283;55770;122433;25428;187527;5487;;;;;
10;610;610;506687;540069;101253;405354;162;405516;810;5312;148;13;0;4;1;132;405389;132;143;405246;8427;4536;3025;866;396819;8597;54479;25340;184929;30247;86083;5457;1687;;;;
11;863;863;686206;731875;140894;545200;212;545412;1130;6920;202;30;2;3;0;169;545274;169;279;544995;11867;5956;4836;1075;533128;8653;77313;41188;221031;36383;138038;7747;2775;;;;
12;474;474;457019;492566;86572;370439;186;370625;801;3971;176;10;0;0;0;166;370535;166;147;370388;5717;3457;2260;0;364671;6487;54585;22036;156308;28754;88408;8093;;;;;
13;895;895;900759;957821;133832;766698;562;767260;1277;14219;531;30;10;4;11;482;766959;482;325;766634;9112;4097;3816;1199;757522;11416;127693;83633;232430;58435;232799;11116;;;;;
14;667;667;567560;609740;133259;434300;371;434671;812;13737;355;39;0;5;1;310;434525;307;59;434466;7174;4260;2914;0;427292;10643;49487;13594;229587;37301;68804;17876;;;;;
15;679;679;534551;568577;124573;409941;271;410212;821;4824;260;19;1;0;1;239;410094;238;114;409980;6389;3722;2667;0;403591;5566;75229;16152;196433;32241;68690;9280;;;;;
16;757;757;584789;627344;133223;451474;171;451645;877;7596;158;8;1;1;2;146;451555;147;105;451450;8883;5415;3468;0;442567;8984;75526;28848;195218;28877;99146;5968;;;;;
17;638;638;496403;534819;98259;398113;210;398323;764;7378;200;12;0;0;2;186;398196;184;242;397954;6752;4045;2707;0;391202;6673;54690;20874;190418;28593;82003;5983;1968;;;;
18;988;988;687778;736338;136387;551292;329;551621;1136;10706;310;34;3;1;5;267;551476;266;147;551329;11921;6181;4522;1218;539408;10045;83681;26149;262236;44299;100902;10229;;1044;;823;
19;1229;1229;2062227;1993723;320002;1728533;911;1729444;1653;63438;830;59;1;6;2;766;1728985;1813;1340;1727645;12926;6056;6870;0;1714719;23450;227127;230648;345380;124220;741286;22608;;;;;
20;738;738;840270;896957;101490;738772;397;739169;1069;19912;367;23;1;2;5;337;738998;337;333;738665;7921;4044;3877;0;730744;16571;110086;51556;231905;51573;257470;11583;;;;;
21;1021;1021;689329;737189;198560;490668;304;490972;914;6444;280;32;2;2;2;244;490788;244;158;490630;10662;6860;3802;0;479968;7521;61155;34763;150022;31150;161241;8338;;;;;25778
22;887;887;629277;662734;179223;450046;280;450326;1297;9928;265;17;2;0;0;246;450230;246;114;450116;8120;5029;3091;0;441996;9165;60938;19750;241790;38080;70054;;2219;;;;
23;1041;1041;914143;955621;231716;682593;332;682925;1620;7669;317;24;1;0;4;288;682703;288;229;682474;8698;4844;3854;0;673776;10302;83676;32828;347688;63854;119259;16169;;;;;
24;1066;1066;829171;881094;209563;619537;360;619897;1394;15150;335;33;5;1;3;295;619669;295;247;619422;10178;5119;4087;972;609244;7081;114898;29478;258277;59648;126971;9998;2893;;;;
25;711;711;761756;827151;134534;627016;392;627408;946;13692;363;24;1;1;1;337;627071;337;445;626626;10339;5632;3465;1242;616287;8871;90599;57967;155318;38406;257009;8117;;;;;
26;981;981;860957;925938;167518;693385;401;693786;1122;14709;387;58;9;2;3;316;693570;317;381;693189;10290;5536;4754;0;682899;11084;92793;56887;199709;49203;258909;14314;;;;;
27;480;480;550469;587203;99143;451177;411;451588;971;8734;393;36;3;2;6;347;451339;348;237;451102;5756;3107;2649;0;445346;7683;64778;34601;163506;34909;127677;10950;;1242;;;
28;483;483;416161;444929;85792;330374;299;330673;648;3902;280;43;0;0;1;236;330566;238;261;330305;6364;3402;2194;768;323941;6775;47698;30497;117756;21256;94313;5646;;;;;
29;468;468;512799;550109;119395;393307;298;393605;655;4218;291;34;3;0;5;249;393440;248;280;393160;5752;3184;2568;0;387408;7378;51681;35673;116827;26934;139711;9204;;;;;
30;433;433;498548;533844;110329;388247;230;388477;774;3661;224;25;1;2;2;194;388364;193;108;388256;6658;3404;2488;766;381598;8647;47525;26117;145230;30527;114404;9148;;;;;
31;559;559;660127;702884;126892;533220;393;533613;910;7392;362;39;2;0;1;320;533498;318;615;532883;6716;3520;3196;0;526167;9488;69825;44509;162458;35240;193596;11051;;;;;
32;445;445;469387;506119;86598;382728;240;382968;685;6292;217;27;3;0;4;184;382862;184;227;382635;4676;2700;1976;0;377959;5499;37221;81646;112389;21512;114519;5173;;;;;
33;1202;1202;890164;946053;217449;672672;365;673037;1512;12070;340;28;5;0;3;304;672872;303;283;672589;13457;7088;5300;1069;659132;18961;90975;45048;310266;43197;137941;9090;2310;1344;;;
34;563;563;428847;455241;120790;307962;157;308119;511;5273;151;15;2;0;2;132;308051;131;120;307931;8551;5248;2682;621;299380;4322;46101;24269;105373;19590;95410;3339;;976;;;
35;730;730;560329;589324;158946;401365;264;401629;782;7975;250;22;1;1;2;224;401540;225;166;401374;10316;5935;3438;943;391058;7728;63007;31631;126432;27119;129339;5802;;;;;
36;944;944;705650;754649;149343;556362;297;556659;806;5234;286;26;2;0;4;254;556494;253;165;556329;14062;8172;4639;1251;542267;12934;87628;46222;194416;37838;154990;8239;;;;;
37;650;650;552339;586375;122787;429730;191;429921;690;5201;188;16;2;0;0;170;429822;170;220;429602;10359;6084;3512;763;419243;9851;69740;39761;162192;29208;100580;5776;2135;;;;
38;683;683;543239;581291;117906;425265;137;425402;711;5834;129;6;0;0;1;122;425294;122;180;425114;11879;7283;3556;1040;413235;7878;72996;32378;120301;28370;144114;7198;;;;;
39;504;504;683940;723283;81353;602589;325;602914;774;10015;292;22;2;0;3;265;602664;265;498;602166;6128;3411;2717;0;596038;9477;98589;73345;116666;35182;262779;;;;;;
40;589;589;447164;475274;116947;330193;185;330378;657;14999;168;10;3;1;0;154;330284;154;62;330222;8073;5359;2714;0;322149;5264;39776;28101;101023;19379;124625;3981;;;;;
41;793;793;718629;771809;153443;564936;299;565235;1031;13499;268;20;3;4;5;238;564942;238;207;564735;10427;6305;4122;0;554308;8985;69957;52032;159575;32942;222427;6218;2172;;;;`;

export const parties = [
  { name: 'PiS', threshold: 5 },
  { name: 'KO', threshold: 8 },
  { name: 'Trzecia Droga', threshold: 8 },
  { name: 'Lewica', threshold: 5 },
  { name: 'Konfederacja', threshold: 5 },
  { name: 'MN', threshold: 0 },

];

